(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("party", [], factory);
	else if(typeof exports === 'object')
		exports["party"] = factory();
	else
		root["party"] = factory();
})(self, function() {
return 